import { FormValues } from "../common/FormValues";
import React, { useEffect, useState } from "react";
import { useAuth } from "oidc-react";
import Button from "../button/Button";
import LoadIncompleteIntakeModal from "./LoadIncompleteIntakeModal";
import { useSearchParams } from "react-router-dom";
import { ButtonClass } from "../enums/ButtonClass";
import { useFormikContext } from "formik";
import { useQuery } from "@apollo/client";
import { FIND_INCOMPLETE_INTAKES_QUERY } from "../../Queries";
import { getKeyByValue } from "../enums/KeyFinder";
import { Party } from "../enums/Party";
import { BenefitType } from "../enums/BenefitType";
import { IncompleteIntake } from "../../generated/graphql";

const IncompleteIntakeStart = () => {
    const { values } = useFormikContext<FormValues>();
    const [searchParams] = useSearchParams()
    const [showModal, setShowModal] = useState<boolean>(false)
    const auth = useAuth();
    const userData = auth.userData;
    const signedIn = !!userData;
    const { data: findIncompleteIntakes } = useQuery(FIND_INCOMPLETE_INTAKES_QUERY, {
        skip: !signedIn
    })
    const incompleteIntakes = findIncompleteIntakes?.findIncompleteIntakes as IncompleteIntake[]
    const formStateParam = searchParams.get("formState");

    useEffect(() => {
        if(formStateParam && formStateParam !== window.sessionStorage.getItem("formState")) {
            window.sessionStorage.setItem("formState", formStateParam);
            setShowModal(true)
        }
    }, [formStateParam])

    const incompleteIntake = incompleteIntakes?.find((incompleteIntake) =>
        incompleteIntake.party === getKeyByValue(Party, values.party)
        && incompleteIntake.benefit === getKeyByValue(BenefitType, values.benefit)
    )
    const signedInWithNoIncompleteIntake = signedIn && !incompleteIntake;
    if(signedInWithNoIncompleteIntake) {
        return null;
    }

    const formState = formStateParam || incompleteIntake?.encryptedFormData

    return <>
        {signedIn &&
            <div className="flex-gap">
                <div>Need to continue where you left off?</div>
                <Button mainButtonClass={ButtonClass.DEFAULT} buttonContent="Continue form" onClick={() => {
                    setShowModal(true)
                }}/>
            </div>}
        {showModal && <LoadIncompleteIntakeModal formState={formState} onModalClose={() => setShowModal(false)}/>}
    </>
}

export default IncompleteIntakeStart;